var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "su7ri3ar2a",
    d: "M0 0.833L14.921 0.833 14.921 2 0 2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M11.354 4.37c0 2.246-1.743 4.066-3.893 4.066-2.15 0-3.893-1.82-3.893-4.066C3.568 2.124 5.31.304 7.46.304c2.15 0 3.893 1.82 3.893 4.066M10.586 11.948h-6.25c-.31 0-.56-.26-.56-.583 0-.323.25-.584.56-.584h6.25c.309 0 .559.261.559.584 0 .322-.25.583-.56.583",
    transform: "translate(0 .696)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M9.556 10.192h-4.19c-.31 0-.56-.26-.56-.583 0-.323.25-.584.56-.584h4.19c.309 0 .559.261.559.584 0 .322-.25.583-.56.583",
    transform: "translate(0 .696)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .696) translate(0 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y80g1xc62b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#su7ri3ar2a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M14.362 2H.558C.25 2 0 1.74 0 1.416 0 1.094.25.833.558.833h13.804c.31 0 .56.261.56.583 0 .323-.25.584-.56.584",
    mask: "url(#y80g1xc62b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M13.712 24.244H1.209c-.308 0-.559-.26-.559-.584 0-.322.251-.583.559-.583h12.503c.309 0 .559.261.559.583 0 .323-.25.584-.559.584",
    transform: "translate(0 .696)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M9.083 12.061L7.448 12.061 7.314 12.061 5.679 12.061 1.894 24.356 7.314 24.356 7.448 24.356 12.868 24.356z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChess);
export default __webpack_public_path__ + "static/media/chess.db501c9266a127dae0039bbef5217be3.svg";
export { ForwardRef as ReactComponent };